import React, { useState } from 'react'
import CambioCerealValido from './CambioCerealValido'
import CambiosDeCerealExportadorView from '../components/CambiosDeCerealExportadorView'
import { connect } from 'react-redux'
import CamposBusqueda from '../components/listados/CamposBusqueda'
import { ToastContainer } from 'react-toastify'
import { FORM_CAMBIO_CEREAL_EXPORTADOR } from '../../../config/forms'
import { parseEntityId } from '../../../models/entity'
import { formValueSelector, reduxForm } from 'redux-form'
import { INTERVALO_CORTO } from '../../../config/settings'
import { actualizarDatoCambioCerealExportador } from '../actions/listados'
import { Card } from 'react-bootstrap'
import CamposCambioCereal from '../components/CamposCambioCereal'
import { crearCambioCereal } from '../actions'

function CambioCerealExportador (props) {
  const { change: formChange, actualizarDatoCambioCerealExportador, crearCambioCereal } = props
  const [show, setShow] = useState(false)

  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaDesde', fechaD)
    formChange('fechaHasta', fechaH)
  }

  const handleSubmit = () => {
    const { fechaDesde, fechaHasta, exportadorBusqueda, cerealBusqueda } = props
    const exportador = parseEntityId(exportadorBusqueda) || null
    const cereal = (cerealBusqueda && (cerealBusqueda.trim() !== 'UNDEF') && cerealBusqueda.trim()) || null
    actualizarDatoCambioCerealExportador(fechaDesde, fechaHasta, exportador, cereal)
    setShow(true)
  }

  const handleCrearCambio = () => {
    const { cerealBusquedaO, cerealBusquedaD } = props
    if (cerealBusquedaO && cerealBusquedaD) {
      crearCambioCereal(cerealBusquedaO, cerealBusquedaD)
    }
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <CamposBusqueda actualizarFechas={actualizarFechas} handleSubmit={handleSubmit} />
      { show && <CambiosDeCerealExportadorView /> }

      <Card className='shadow bg-white rounded' style={{ margin: '3% auto', padding: '22px' }}>
        <h6>Definir cambio de cereal</h6>
        <CamposCambioCereal handleSubmit={handleCrearCambio} />
      </Card>

      <CambioCerealValido />
    </>
  )
}

const selector = formValueSelector(FORM_CAMBIO_CEREAL_EXPORTADOR)

const mapStateToProps = (state) => ({
  cerealBusquedaO: selector(state, 'cerealOrigen'),
  cerealBusquedaD: selector(state, 'cerealDestino')
})

const mapActionsToProps = {
  actualizarDatoCambioCerealExportador,
  crearCambioCereal
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_CAMBIO_CEREAL_EXPORTADOR
})
export default withRedux(withReduxForm(CambioCerealExportador))
